import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'calendars'
AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Calendar.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  text: $vm => $vm.$t(`${base}.title`),
  header: $vm => $vm.$t(`general.menu_management`),
  route: {
    name: `${base}`,
  },
  icon: 'icon-calendar2',
  permission: 'administer',
})

messageGroups.push(base)
